import ImageZoom from "../../../../src/components/ImageZoom";
import * as React from 'react';
export default {
  ImageZoom,
  React
};